import styled from 'styled-components';

const Styles = styled.div`
	margin: 10px -10px;

	.collapse {
		width: 0.0000000001%;
	}
`;

export default Styles;
